import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PageNotFound from '../features/errors/pages/PageNotFound';
import UnexpectedError from '../components/errors/UnexpectedError';
import RequireAuth from '../components/auth/RequireAuth';
import ListVehicles from '../features/vehicles/pages/ListVehicles';
import ViewVehicle from '../features/vehicles/pages/ViewVehicle';
import Profile from '../features/profile/pages/Profile';
import Login from '../features/auth/pages/Login';
import SignUp from '../features/auth/pages/SignUp';
import VerifyEmail from '../features/auth/pages/VerifyEmail';
import VerifyEmailFailed from '../features/errors/pages/VerifyEmailFailed';
import RequireProfile from '../components/auth/RequireProfile';
import LiveAuction from '../features/auction/pages/LiveAuction';
import NextAuction from '../features/auction/pages/NextAuction';
import AuctionResult from '../features/auction/pages/AuctionResult';
import ForgotPassword from '../features/auth/pages/ForgotPassword';
import PasswordReset from '../features/auth/pages/PasswordReset';

const routes = (
  <BrowserRouter>
    <Routes>
      <Route path='/login' element={<Login />}></Route>
      <Route path='/signUp' element={<SignUp />}></Route>
      <Route path='/verify-email' element={<VerifyEmail />}></Route>
      <Route path='/verify-email-failed' element={<VerifyEmailFailed />} />
      <Route path='/forgot-password' element={<ForgotPassword />}></Route>
      <Route path='/password-reset' element={<PasswordReset />}></Route>
      <Route path='/' element={<RequireAuth />}>
        <Route index element={<Navigate to='/vehicles' replace />} />
        <Route path='/profile' element={<Profile />}></Route>
        <Route path='/' element={<RequireProfile />}>
          <Route path='/vehicles' element={<ListVehicles />} />
          <Route path='/vehicles/:vehicleId' element={<ViewVehicle />} />
          <Route path='/auctions/next' element={<NextAuction />}></Route>
          <Route path='/auctions/live' element={<LiveAuction />}></Route>
          <Route path='/auctions/result' element={<AuctionResult />}></Route>
        </Route>
      </Route>
      <Route path='/error' element={<UnexpectedError />} />
      <Route path='*' element={<PageNotFound />} />
    </Routes>
  </BrowserRouter>
);

export default routes;
